import {FetchPolicy} from '@apollo/client';

import {
  AnalysisTemplateSelectorQuery,
  AnalysisTemplateSelectorQueryVariables,
} from 'analysis-tool/graphql/__generated/AnalysisTemplateSelectorQuery';
import {ANALYSIS_TEMPLATE_SELECTOR_QUERY} from 'analysis-tool/graphql/AnalysisTemplateSelectorQuery';
import {doQuerySafe} from 'graphql-client/ApolloWrappers';

export default async function refreshTemplateSelectorQuery(fetchPolicy: FetchPolicy): Promise<void> {
  await doQuerySafe<AnalysisTemplateSelectorQuery, AnalysisTemplateSelectorQueryVariables>(
    {query: ANALYSIS_TEMPLATE_SELECTOR_QUERY},
    {fetchPolicy}
  );
}
